<template>
  <OnlineTestWiseAnalysis 
    testType="myt" 
    :studentId="student_id"
    :batchId="batch_id"
  />
</template>

<script>
import OnlineTestWiseAnalysis from './OnlineTestWise-Analysis.vue';
import constants from "@/utils/constants.js";

export default {
  name: 'MYTTestAnalysis',
  components: {
    OnlineTestWiseAnalysis
  },
  props: {
    student_id: {
      type: [Number, String],
      default: null
    },
    batch_id: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      constants: constants
    };
  }
};
</script>

